import { CallingStatus } from "../../../../enums/callingStatus";

export const allCallingStatusOptions = [
  { label: "Resolved", value: CallingStatus.RESOLVED },
  { label: "Unresolved", value: CallingStatus.UNRESOLVED },
  { label: "Call Not Needed", value: CallingStatus.CALL_NOT_NEEDED },
];
